import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { CLIENT_ID } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsService {

  private readonly TERMS_AND_CONDITIONS_STORAGE_KEY = `app.t&c.flag.${CLIENT_ID}`;

  private _flag: WritableSignal<boolean> = signal(this.getTermsAndConditionsFlagFromLocalStorage());
  public flag: Signal<boolean> = this._flag.asReadonly();
  public isTermsAndConditionConfirmed: Signal<boolean> = computed(() => this._flag());

  constructor() { }

  setFlag(value: boolean) {
    this._flag.set(value);
    this.setTermsAndConditionsFlagInLocalStorage(value);
  }

  setTermsAndConditionsFlagInLocalStorage(flag: boolean): void {
    localStorage.setItem(this.TERMS_AND_CONDITIONS_STORAGE_KEY, flag.toString());
  }

  removeTermsAndConditionsFlagFromLocalStorage(): void {
    localStorage.removeItem(this.TERMS_AND_CONDITIONS_STORAGE_KEY);
  }

  getTermsAndConditionsFlagFromLocalStorage(): boolean {
    return Boolean(localStorage.getItem(this.TERMS_AND_CONDITIONS_STORAGE_KEY));
  }

}
